import React from 'react';
import { observer } from 'mobx-react-lite';
import { StatusWrapper } from './StatusLabel.style';

interface StatusLabelPropsType {
    status: 'live' | 'scheduled' | 'ended' | 'info' | '',
    children?: JSX.Element | string;
}

export const StatusLabel = observer(({ status, children }: StatusLabelPropsType) => {
    const statusText = children === undefined ? status : children;

    return (
        <>
            {status === '' ? null : <StatusWrapper status={status}>{statusText}</StatusWrapper>}
        </>
    );
});
